import { matchSorter } from 'match-sorter';
import { Autocomplete, Tooltip, Typography } from 'seagull';
import { Accounting } from "../../../types/api.model";
import { hasSalesAccount } from "../../../models/accounting-integration";
import { getAccountingDetails } from "../accounting.utils";
import styles from "./ServiceAccountingAutocomplete.module.scss";
import { capitalize } from 'lodash-es';
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { AccountingItemType } from "../../../types/api/accounting-integration";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const ServiceAccountingAutocomplete = _ref => {
  let {
    accountingItems,
    selectedOption,
    isDisabled,
    hasError,
    onItemChange: onAccountingItemChange,
    testid,
    showAccountingMapPlaceHolder,
    accounting,
    isBundle
  } = _ref;
  const isLoading = !accountingItems;
  const {
    fullName,
    items,
    name
  } = getAccountingDetails(accounting);
  const {
    SERVICE_TEMPLATE_BUNDLE
  } = useFeatureFlags();
  const _getOptionDisabled = option => {
    if (accounting === Accounting.Xero && !hasSalesAccount(option)) return /*#__PURE__*/_jsxs("div", {
      "data-testid": "".concat(testid, "-tooltip"),
      children: ["Item is missing a Sales account in ", getAccountingDetails(accounting).name]
    });
    if (accounting === Accounting.QBO && isBundle && option.type === AccountingItemType.Service) return /*#__PURE__*/_jsxs("div", {
      "data-testid": "".concat(testid, "-tooltip"),
      children: ["Services can't be selected for bundles. Create a bundle in", ' ', getAccountingDetails(accounting).fullName, ", then map it here."]
    });
    return undefined;
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    title: isDisabled ? "".concat(fullName, " ").concat(items, " can be mapped through the ").concat(items, " library") : '',
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Autocomplete, {
        "data-testid": testid,
        value: selectedOption,
        options: accountingItems || [],
        onChange: (_, newOption) => onAccountingItemChange(newOption),
        renderOption: option => /*#__PURE__*/_jsx("div", {
          className: styles.accountingItemOption,
          "data-testid": "".concat(testid, "-option-").concat(option.id),
          children: /*#__PURE__*/_jsx(Tooltip, {
            placement: "top",
            title: _getOptionDisabled(option) || '',
            children: SERVICE_TEMPLATE_BUNDLE ? /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx(Typography, {
                skin: "primary",
                ellipsis: true,
                children: option.name
              }), /*#__PURE__*/_jsx(Typography, {
                "data-testid": "option-type-".concat(option.id),
                ellipsis: true,
                children: capitalize(option.type)
              })]
            }) : /*#__PURE__*/_jsx(Typography, {
              skin: "primary",
              ellipsis: true,
              children: option.name
            })
          })
        }),
        getOptionSelected: (option, value) => option.id == value.id,
        getOptionLabel: option => option.name,
        filterOptions: (options, _ref2) => {
          let {
            inputValue
          } = _ref2;
          const filteredItems = matchSorter(options, inputValue, {
            keys: ['name']
          });
          return filteredItems;
        },
        getOptionDisabled: option => !!_getOptionDisabled(option),
        noOptionsText: "No ".concat(name, " ").concat(items),
        loading: isLoading,
        disabled: isLoading || isDisabled,
        textFieldProps: {
          alwaysShrinkLabel: showAccountingMapPlaceHolder,
          label: "".concat(fullName, " mapping"),
          placeholder: isLoading ? '' : 'Not mapped',
          error: hasError
        },
        selectOnFocus: true,
        disableClearable: false,
        multiple: false,
        freeSolo: false
      })
    })
  });
};
export default ServiceAccountingAutocomplete;